/**
 * Defines options for displaying actions in ZeroData component.
 */
export var ZeroDataActionType;
(function (ZeroDataActionType) {
    ZeroDataActionType[ZeroDataActionType["ctaButton"] = 0] = "ctaButton";
    ZeroDataActionType[ZeroDataActionType["link"] = 2] = "link";
})(ZeroDataActionType || (ZeroDataActionType = {}));
